export default __webpack_public_path__ + "static/media/Closed_Invoice.67ba13fb.svg";